














import {
	defineComponent,
} from '@vue/composition-api';
import TrButton from '@front-app/components/buttons/TrButton.vue';

export default defineComponent({
	components: {
		TrButton,
	},
	props: {
		isActive: {
			type: Boolean,
			required: true,
		},
		activeLabel: {
			type: String,
			required: true,
		},
		inactiveLabel: {
			type: String,
			required: true,
		},
		disabled: Boolean,
	},
	setup() {
		return {};
	},
});
